export default {
  ConfigInfo(state) {
    return state.ConfigInfo;
  },
  CurrentDate(state) {
    return state.ConfigInfo.CurrentDate;
  },
  Context(state) {
    return state.Context;
  },
  NumberFormat(state) {
    return state.NumberFormat;
  },
  Culture(state) {
    return state.Context.Culture;
  },
  OptionsData(state) {
    return state.OptionsData;
  },
  Token(state) {
    return state.Token;
  },
  Loading(state) {
    return state.Loading;
  },
  User(state) {
    return state.User;
  },
  Permission(state) {
    return state.Permission;
  },
  LeftMenuCollapse(state) {
    return state.LeftMenuCollapse;
  },
  Culture(state) {
    return state.Culture;
  },
  PostedDate(state) {
    return state.PostedDate;
  },
  LoadFormMaster(state){
    return state.loadFormMaster;
  },
  DeviceID(state) {
    return state.DeviceID;
  }

};
